import React from "react"
import { Facebook, Instagram, Twitter } from "@styled-icons/boxicons-logos"

import { Element } from "legacy/components/shared/base"
import LinkIcon from "legacy/components/shared/LinkIcon"
import { useTheme } from "src/legacy/utils"

const SocialNav: React.FC = (): React.ReactElement => {
  const { colors, sizes } = useTheme()

  return (
    <Element
      alignItems="flex-end"
      display="flex"
      gridArea="social"
      justifyContent={["center", "flex-start"]}
      mt={["55", "0"]}
      pb={["5", "5", "0"]}
      pl={["2px", "4px"]}
    >
      <LinkIcon
        iconColor={colors.white}
        iconHoverColor={colors.aqua}
        mr="15"
        size={[sizes.iconMobile, sizes.iconMobile, sizes.iconDesktop]}
        href="instagram"
      >
        <Instagram />
      </LinkIcon>
      <LinkIcon
        iconColor={colors.white}
        iconHoverColor={colors.aqua}
        mr="15"
        size={[sizes.iconMobile, sizes.iconMobile, sizes.iconDesktop]}
        href="twitter"
      >
        <Twitter />
      </LinkIcon>
      <LinkIcon
        iconColor={colors.white}
        iconHoverColor={colors.aqua}
        size={[sizes.iconMobile, sizes.iconMobile, sizes.iconDesktop]}
        href="facebook"
      >
        <Facebook />
      </LinkIcon>
    </Element>
  )
}

export default SocialNav
